import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lang" }
const _hoisted_2 = {
  key: 0,
  class: "lang-name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Flag = _resolveComponent("Flag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Flag, {
      class: "lang-flag",
      lang: _ctx.lang
    }, null, 8, ["lang"]),
    (_ctx.full)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.langFull), 1))
      : _createCommentVNode("", true)
  ]))
}